import { render, staticRenderFns } from "./BlogListing.vue?vue&type=template&id=633d390a"
import script from "./BlogListing.vue?vue&type=script&lang=js"
export * from "./BlogListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports